export function section02() {
    let animationComplete = false
    let logoAnimation = document.getElementById("crea_aci_logo")
    logoAnimation.pause()

    gsap.from(".section.slice-2 #logo-wrapper", {
        opacity: 0,
        duration: 0.75,
        ease: "power2.inOut",
        scrollTrigger: {
            trigger: ".section.slice-2",
            start: "center bottom",
            scrub: false,
        },
        onStart: () => {
            logoAnimation.play()
        },
        onComplete: () => {
            animationComplete = true
        },
    })

    gsap.to(".section.slice-2 img#backdrop", {
        scale: 1.15,
        duration: 2,
        ease: "Power1.easeOut",
        scrollTrigger: {
            trigger: ".section.slice-2",
            start: "center bottom",
            end: "center 5%",
            scrub: 1,
        },
    })

    // create intersection observer to pause video if not in view
    let observer = new IntersectionObserver(function (entries) {
        if (animationComplete === true) {
            if (!entries[0].isIntersecting) {
                logoAnimation.pause()
                logoAnimation.seek(0)
                gsap.set(".section.slice-2 #logo-wrapper", {
                    opacity: 0,
                })
            } else {
                gsap.to(".section.slice-2 #logo-wrapper", {
                    opacity: 1,
                    duration: 0.75,
                    ease: "power2.inOut",
                })
                logoAnimation.play()
            }
        }
    });

    observer.observe(document.querySelector("section.slice-2 #logo-wrapper"))

}